// CommentsEmojiSelector.jsx

import React from 'react';

// CSS
import './CommentsEmojiSelector.css';

/**
 * CommentsEmojiSelector
 *
 * @returns {ReactNode} The rendered component.
 */
const CommentsEmojiSelector = ({ onEmojiClick }) => {

    // Common emojis (you can expand this list)
    const emojis = [
        '😊', '😂', '❤️', '👍', '😍', '😢', '😡', '😮', '🙌', '🔥',
        '✨', '👏', '🤓', '😎', '🥳', '🎉', '🌟', '💪', '🤗', '🙏'
    ];

    // ----- RENDER ----- //

    return (
        <div
            className="emoji-selector-container">
            {emojis.map((emoji, index) => (
                <button
                  className="emoji-button"
                  style={{
                    color: '#FFFFFF',
                  }}
                  key={index}
                  onClick={() => onEmojiClick(emoji)}
                >
                    {emoji}
                </button>
            ))}
        </div>
    );
};

// Dev Tools
CommentsEmojiSelector.displayName = 'CommentsEmojiSelector';

export default CommentsEmojiSelector;
